import React from 'react'
import Context from './Context'
import { VerticalsProviderProps } from './types'

const Main = ({ children }: VerticalsProviderProps) => <Context>{children}</Context>

export default Main
